module.exports = __webpack_public_path__ + "img/customerBindHandFail.9384f78e.png";